import { LOAD_STATE } from '../../types/api';
import { APIController } from '../api/controller';
import { EnvModel } from '../env/model';
import { WebContentModel } from './model';
import { action, autorun, IReactionDisposer } from 'mobx';

export class WebContentController {
  private _disposers: IReactionDisposer[];

  constructor(private model: WebContentModel, private api: APIController) {
    this._disposers = [];

    this._disposers.push(
      autorun(() => {
        if (this.model.featuredVideosStatus === LOAD_STATE.EMPTY) {
          this.loadFeaturedVideos();
        }
      })
    );
  }

  dispose = () => {
    this._disposers.forEach((dispose) => dispose());
  };

  @action
  loadFeaturedVideos = async () => {
    this.model.featuredVideosStatus = LOAD_STATE.LOADING;

    try {
      const response = await this.api.webContent.fetchFeaturedVideos();
      this.model.featuredVideos = response.data;
      this.model.featuredVideosStatus = LOAD_STATE.READY;
    } catch (error) {
      this.model.featuredVideosStatus = LOAD_STATE.ERROR;
    }
  };
}
